<!-- /src/components/common/List/DownloadListing.vue -->
<template>
  <div class="card"
    :class="{'card__small': cardSize == 'small'}"
  >
    <a
      class="downloadable__item card__content" 
      :href="url" 
      target="_blank" 
      download
    >
      <div class="card__content__container">
        <div class="card_type__container">
          <i
            v-if="icon.iconType == 'fontawesome'"
            class="card_type icon fas"
            :class="icon.cssClass"
          />
          <img v-else
            class="card_type image icon"
            :class="icon.cssClass"
            :src="icon.imgSrc"
          />
        </div>
        <div class="card__title"
        >
          <h3 v-html="title"></h3>
          <div v-if="cardTaxonomyDisplay" class="card__author">
            {{ cardTaxonomyDisplay }}
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
// import AuthorChip from '@/components/Bio/AuthorChip'
import secondConversions from '@/components/common/utils/filters/secondConversions'
import postMixin from '@/mixins/postMixin'
import _isUndefined from 'lodash/isUndefined'
import { checkNested } from '@/components/common/utils/helpers'

export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
    cardSize: {
      type: String,
      required: false,
    }
  },

  mixins: [postMixin],

  computed: {
    // title() {
    //   const { post } = this
    //   const title = checkNested(post, 'title', 'rendered') ? post.title.rendered : post.post_title
    //   return title
    // },
    cardTaxonomyDisplay() {
      return ''
    },
    
    file() {
      const { post } = this
      const { file } = post
      return file
    },
    url() {
      const { url } = this.file
      return url ? url : false
    },

    base() {
      const { url } = this.file
      return url ? url : false
    },

    title() {
      const { title } = this.file
      return title ? title : false
    },

    caption() {
      const { caption } = this.file
      return typeof caption != 'undefined' && caption.trim() ? caption : false
    },

    extension() {
      const { file } = this
      const re = /(?:\.([^.]+))?$/
      return re.exec(file.filename)[1]
    },

    mimeType() {
      const { file } = this
      return file['mime_type'] && typeof file['mime_type'] != 'undefined' ? file['mime_type'] : false
    },

    icon() {
      const { extension } = this
      const fonticon = 'fas ';
      let cssClass = false
      let iconType = false
      let imgSrc = false
      switch (extension) {
        case 'pdf':
          cssClass = 'image'
          iconType = 'image'
          imgSrc = '/wp-content/themes/carr_edu_vue/src/assets/adobe_pdf_icon.svg'
          break
        case 'eps':
          cssClass = fonticon + 'fa-bezier-curve'
          iconType = 'fontawesome'
          break
        case 'doc':
        case 'docx':
        case 'dotm':
        case 'dotx':
          cssClass = 'downloadImage fa-file-word'
          iconType = 'image'
          imgSrc = '/wp-content/themes/carr_edu_vue/src/assets/ms_doc_icon.svg'
          break
        case 'rtf':
        case 'txt':
          cssClass = fonticon + 'fa-align-left'
          iconType = 'fontawesome'
          break
        case 'ods':
        case 'xls':
        case 'xlsx':
        case 'xlsm':
        case 'xltm':
        case 'xltx':
          cssClass = 'fa-file-spreadsheet'
          iconType = 'image'
          imgSrc = '/wp-content/themes/carr_edu_vue/src/assets/ms_xls_icon.svg'
          break
        case 'pptx':
        case 'ppsx':
        case 'pptm':
        case 'ppt':
          cssClass = 'fa-file-powerpoint'
          iconType = 'image'
          imgSrc = '/wp-content/themes/carr_edu_vue/src/assets/ms_ppt_icon.svg'
          break
        case 'zip':
        case 'gzip':
          cssClass = fonticon + 'fa-file-archive'
          iconType = 'fontawesome'
          break
        case 'csv':
          cssClass = fonticon + 'fa-file-csv'
          iconType = 'fontawesome'
          break
        case 'mp4':
        case 'm4a':
        case 'mov':
        case 'webm':
        case 'flv':
        case 'ogg':
          cssClass = fonticon + 'fa-video'
          iconType = 'fontawesome'
          break
        case 'mp4':
        case 'm4a':
        case 'mov':
        case 'webm':
        case 'flv':
        case 'ogg':
          cssClass = fonticon + 'fa-microphone-alt'
          iconType = 'fontawesome'
          break
        case 'png':
        case 'tif':
        case 'jpg':
        case 'jpeg':
        case 'gif':
          cssClass = 'far fa-image-polaroid'
          iconType = 'fontawesome'
          break
        case 'eml':
        case 'emltpl':
        case 'msg':
          cssClass = 'fa-envelope-open-text'
          iconType = 'image'
          imgSrc = '/wp-content/themes/carr_edu_vue/src/assets/ms_eml_icon.svg'
          break
        default:
          cssClass = fonticon + 'fa-file-exclamation'
          iconType = 'fontawesome'
      }
      return {
        cssClass,
        iconType,
        imgSrc,
      }
    },
  },


  // components: {
  //   AuthorChip,
  // },

  filters: {
    ...secondConversions,
  },
}
</script>

<style scoped>
.card {
  background-color: white;
  height: 100%;
  width: 100%;
  box-shadow: 0 0 1rem rgba(154, 162, 178, 0);
  transition: box-shadow 0.5s ease, transform 0.5s ease;
  border-radius: 4px;
  overflow: hidden;
  will-change: box-shadow, transform;

  &__small {
      font-size: .8em;
  }

  &:hover {
    box-shadow: 0 0.5rem 1rem rgba(154, 162, 178, 0.5);
    transform: translateY(-5px);

    .card__bottom {
      background-color: var(--brandAccent);
    }
  }

  @media (--tablet) {
    margin-bottom: 0;
  }

  &__content {
    cursor: pointer;

    &__container {
      padding: 0.75rem 1rem;
      display: grid;
      align-content: center;
      grid-template-columns: min-content 1fr;
    }
  }

  &__footer {
    transition: 0.5s background-color;
    background-color: var(--mediumGray);
  }

  &_type {
    &.icon {
      color: white;
      text-align: center;
      background-color: var(--brandAccent);
      border-radius: 50%;
      padding: 0.5em;
      margin: 0;
      width: 2em;
      height: 2em;
      position: relative;

      &.image {
        padding: 0;
        margin: 0;
        display: block;
        background-color: transparent;
      }

      &.fa-play {
        &:before {
          left: 55%;
        }
      }
    }

  }

  &__title {
    color: var(--brandPrimary);
    line-height: 1.1;
    font-size: 0.7em;
    letter-spacing: -0.05em;
    font-weight: 500;
    display: grid;
    align-items: center;

    h3 {
      font-weight: var(--fontWeightBold);
      margin: 0;
      /* max-width: 100%; */

      @media (--desktop-large) {
        /* font-size: 1.4rem; */
      }
    }
  }

  &__date,
  &__duration {
    font-size: 0.7em;
    vertical-align: middle;
  }

  &__author {
    margin: 0.25rem 0 0 0;
    color: var(--brandAccent);
    text-transform: uppercase;
    font-weight: 600;
    font-size: 0.75em;
    line-height: 1.1;
  }

  &__tags {
    font-size: 0.6rem;
    display: inline-flex;
    flex-wrap: wrap;
    margin-bottom: 0;

    &__tag {
      display: inline;
      margin-right: 0.45em;
      font-weight: 500;

      &:after {
        content: ',';
      }

      &:last-child {
        margin-right: 0;

        &:after {
          content: '';
        }
      }
    }
  }

  &__actions {
    padding: 0.75rem 1rem;
    font-size: 0.5em;
    font-weight: var(--fontWeightSemibold);
    text-align: center;

    &__item {
      width: 100%;
      font-size: 1.2em;
      margin-bottom: 0.5em;

      &:last-child {
        margin-bottom: 0;
      }

      &--progress {
        color: var(--lightGray);
        text-transform: uppercase;
        font-weight: var(--fontWeightBold);
        letter-spacing: -0.03em;
      }
    }
  }
}
</style>
